module.exports = __webpack_public_path__ + "img/go-build-old.55a427bc.jpg";